export default {
    getPersonnel: (state) => state.personnel,
    getStatuses: (state) => state.statuses,
    getStatusesMap: (state) => state.statusesMap,
  }